import Timeline from './Timeline';
import TimelineItem from './TimelineItem';
Timeline.Item = TimelineItem;
export default Timeline;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-timeline/src/index.js